import { render } from "./TiltCard.vue?vue&type=template&id=4d5386cf&scoped=true"
import script from "./TiltCard.vue?vue&type=script&lang=js"
export * from "./TiltCard.vue?vue&type=script&lang=js"

import "./TiltCard.vue?vue&type=style&index=0&id=4d5386cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5386cf"]])

export default __exports__